// Guía de tallas — Ana Cristina P.D.

(function () {

  function abrirPopup() {
    var overlay = document.getElementById('guia-tallas-overlay');
    if (!overlay) return;
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function cerrarPopup() {
    var overlay = document.getElementById('guia-tallas-overlay');
    if (!overlay) return;
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  function init() {
    var overlay = document.getElementById('guia-tallas-overlay');
    if (!overlay) return;

    // ── Abrir si la URL ya tiene #guia-tallas al cargar ─────────────────────
    if (window.location.hash === '#guia-tallas') {
      abrirPopup();
    }

    // ── Detectar clicks en cualquier enlace/botón que dispare el popup ───────
    document.addEventListener('click', function (e) {
      var el = e.target.closest(
        'a[href="#guia-tallas"], a[href*="#guia-tallas"], ' +
        '#footer-guia-tallas-btn, #abrir-guia-tallas, .guia-tallas-btn'
      );
      if (el) {
        e.preventDefault();
        history.replaceState(null, '', window.location.pathname + window.location.search);
        abrirPopup();
      }
    });

    // ── Detectar navegación por hash ─────────────────────────────────────────
    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#guia-tallas') {
        abrirPopup();
      }
    });

    // ── Cerrar con botón X ───────────────────────────────────────────────────
    var btnCerrar = document.getElementById('cerrar-popup');
    if (btnCerrar) {
      btnCerrar.addEventListener('click', cerrarPopup);
    }

    // ── Cerrar al hacer clic fuera del popup ─────────────────────────────────
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) cerrarPopup();
    });

    // ── Cerrar con Escape ────────────────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) cerrarPopup();
    });

    // NOTA: el botón #abrir-guia-tallas ya se renderiza desde main-product.liquid
    // usando {{ 'guia_tallas.boton' | t }}, por lo que no se crea aquí con JS.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();